import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeFabricList = (data) => {
	return {
		type: Types.STORE_FABRIC_LIST,
		payload: data
	};
};

export const fetchFabricList =
	(params = 'info.nitex.app.materials.FabricType') =>
	async (dispatch) => {
		await ApiClient.GET('getEnums', params).then((response) => {
			dispatch(storeFabricList(response.data));
		});
	};
